/**
 * Typography Tokens
 * Consistent text styling across the application
 */

export const TYPOGRAPHY = {
  // Page level - aligned with AccountLayout
  pageTitle: "text-2xl sm:text-3xl font-bold",
  pageTitleTight: "text-2xl font-bold tracking-tight",
  pageDescription: "text-sm sm:text-base text-muted-foreground",
  
  // Header greeting (friendly, smaller than page title)
  headerGreeting: "text-lg sm:text-xl font-semibold",
  
  // Section level (h2, h3)
  sectionTitle: "text-lg font-semibold",
  sectionTitleLarge: "text-xl font-semibold",
  sectionSubtitle: "text-base font-medium",
  sectionSubtitleBold: "text-base font-semibold",
  
  // Card level
  cardTitle: "text-base font-medium",
  cardTitleLarge: "text-lg font-semibold",
  cardTitleSmall: "text-sm font-medium",
  cardDescription: "text-sm text-muted-foreground",
  
  // Labels
  label: "text-sm font-medium",
  labelBold: "text-sm font-semibold",
  labelMuted: "text-sm font-medium text-muted-foreground",
  labelXs: "text-xs font-medium text-muted-foreground",
  labelXsBold: "text-xs font-semibold text-muted-foreground",
  labelXsUppercase: "text-xs font-medium text-muted-foreground uppercase tracking-wide",
  labelXsPlain: "text-xs font-medium",
  sectionLabelUppercase: "text-sm font-semibold uppercase text-muted-foreground",
  
  // Content
  body: "text-sm",
  caption: "text-xs text-muted-foreground",
  code: "text-xs bg-muted px-1 py-0.5 rounded font-mono",
  
  // ─────────────────────────────────────────────────────────────────
  // FILTER/FORM TRIGGERS
  // Use for filter buttons, select triggers, and form dropdowns
  // Do NOT use cardDescription for triggers - it has muted color
  // ─────────────────────────────────────────────────────────────────
  filterTrigger: "text-sm",
  
  // Metric values
  metricValue: "text-2xl font-bold",
  metricValueMedium: "text-lg font-bold",
  metricValueSmall: "text-xl font-bold",
  metricValueLarge: "text-3xl font-bold",
  metricValueXL: "text-4xl font-bold",
  metricLabel: "text-sm text-muted-foreground",
  
  // ─────────────────────────────────────────────────────────────────
  // PUBLICATION TYPOGRAPHY
  // Consistent styling for publication body content
  // ─────────────────────────────────────────────────────────────────
  publicationTitle: "text-2xl font-semibold",
  publicationBody: "text-base sm:text-lg leading-relaxed text-foreground/90",
  publicationHeading: "font-semibold text-foreground",
} as const;

export type TypographyToken = keyof typeof TYPOGRAPHY;
